export default __webpack_public_path__ + "static/media/lastlink.alt.8656a7e7.png";